var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 4.5,
    height: 4.5,
    strokeWidth: 1.5,
    stroke: "currentColor",
    rx: 0.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 2,
    width: 4.5,
    height: 4.5,
    strokeWidth: 1.5,
    stroke: "currentColor",
    rx: 0.02
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9.5,
    width: 4.5,
    height: 4.5,
    strokeWidth: 1.5,
    stroke: "currentColor",
    rx: 0.02
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 4.5,
    height: 4.5,
    strokeWidth: 1.5,
    stroke: "currentColor",
    rx: 0.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.f1ddb54ece2771c397fe2189c46c1cf0.svg";
export { ForwardRef as ReactComponent };